import React from 'react'

import { Headline } from '@varta/digital-styleguide/build/src/components/01.atoms'
import {
    CheckboxSlider,
    Form
} from '@varta/digital-styleguide/build/src/components/02.molecules'

import { useFormData } from '../../../redux/data/hooks/useFormData'
import { useNavigation } from '../../../redux/navigation/hooks/useNavigation'
import { useSettings } from '../../../redux/settings/hooks/useSettings'

import {
    APPLICATION_MARINE,
    ENERGY_DEMAND,
    NIGHTS,
} from '../../../data/strings'

import './_index.scss'

const CLASSNAME = 'varta-leisure-marine-wizard'
const cnRow = `${ CLASSNAME }__row`

/**
 * 
 * @returns 
 */
export default function Nights ({ i18n }) {

    const { formData, addInputFormData } = useFormData(APPLICATION_MARINE)
    const { setNextVisibleForm, setConfirmButton } = useNavigation(APPLICATION_MARINE)
    const { mobile } = useSettings()

    /**
     * 
     * @param {event} e 
     */
    function handleChange (e) {
        addInputFormData(NIGHTS, e.target.value)
        setConfirmButton(false)
        setNextVisibleForm(NIGHTS, ENERGY_DEMAND)
    }

    return (
        <>
            <Headline level={ 2 }>
                { i18n[NIGHTS].title }
            </Headline>
            <Form
                onChange={ handleChange }
            >
                <div className={ cnRow }>
                    <CheckboxSlider
                        iconId='night-sky'
                        options={Array.apply(null, Array(5)).map((y, i) => ( { label: String(i + 1), value: String(i + 1) } ))}
                        selected={ formData[NIGHTS] }
                        type={mobile ? 'vertical' : 'horizontal'}
                        />
                </div>
            </Form>
        </>
    )
}